import React, { useState, useEffect } from 'react';
import { useStateValue } from '../context/StateProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFirestore, doc, setDoc, getDoc ,increment, updateDoc, runTransaction} from 'firebase/firestore';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import Font Awesome
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'; // Import the specific icon


const UploadResume = () => {
  const [{ user }] = useStateValue();
  const navigate = useNavigate();
  const location = useLocation();
  const firestore = getFirestore();
 

  const product = location.state?.product;

  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [resumeUrl, setResumeUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const generateWebsiteStyleApplicationId = async (jobId, username) => {
    let jobPart = "JOB1"; // Default to JOB1

    try {
        await runTransaction(firestore, async (transaction) => {
            const counterDocRef = doc(firestore, 'applications');
            const counterDoc = await transaction.get(counterDocRef);

            if (counterDoc.exists()) {
                const currentCount = counterDoc.data().count;
                jobPart = `JOB${currentCount}`;
                transaction.update(counterDocRef, { count: increment(1) });
            } else {
                transaction.set(counterDocRef, { count: 2 }); // Next count will be 2
            }
        });
    } catch (error) {
        console.error("Failed to get or update counter:", error);
    }

    const jobIdPart = String(jobId).substring(0, 3).toUpperCase();

    let userPart = username;
    const spaceIndex = username.indexOf(" ");
    if (spaceIndex !== -1) {
        userPart = username.substring(0, spaceIndex);
    }

    const timestamp = Date.now().toString(36).substring(2, 7).toUpperCase();
    const random = Math.random().toString(36).substring(2, 5).toUpperCase();

    return `${jobPart}-${jobIdPart}-${userPart}-${timestamp}-${random}`;
};

  useEffect(() => {
    const fetchUserData = async () => {
      if (user && user.username) { // Check if user and username are defined
        const userDocRef = doc(firestore, 'users', user.username); // Use username
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setName(userData.username || '');
          setMobile(userData.mobile || '');
          setEmail(userData.email || '');
          setResumeUrl(userData.resume || ''); // Assuming resume URL is stored here
        }
      }
    };

    fetchUserData();
  }, [user, firestore]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!mobile || mobile.trim() === '') {
        toast.error('Before applying for a job, please update your mobile number.');
        navigate('/my-info');
        return;
    }

    if (!resumeUrl) {
        toast.error('You have not uploaded your Resume/CV. Please upload it in My Account.');
        navigate('/my-info');
        return;
    }

    setLoading(true);

    try {
      const applicationId = await generateWebsiteStyleApplicationId(product.id, user.username); // Use await here
        const applicationData = {
          userId: user.username, // Use user.username instead of user.uid
            jobId: product.id,
            applicationId: applicationId,
            name:user.username,
            mobile,
            email,
            resumeUrl,
            appliedAt: new Date(),
            status: 'Pending',
        };

        await setDoc(doc(firestore, 'applications', applicationId), applicationData); // Use username in doc ID
        toast.success('Application submitted successfully!');
        navigate('/job-search');
    } catch (error) {
        console.error('Error submitting application: ', error);
        toast.error('Failed to submit application. Try again later.');
    } finally {
        setLoading(false);
    }
};
  const handleViewResume = () => {
    if (resumeUrl) {
      window.open(resumeUrl, '_blank'); // Open resume in a new tab
    }
  };

  if (!product) {
    return <p>No product data available.</p>;
  }

  return (
    <section className='mt-5' >
      <div className="max-w-4xl mx-auto p-6 lg:p-20 bg-white shadow-sx rounded-sx border border-gray-300 mt-12 lg:mt-5">
        <h2 className="text-3xl font-bold mb-6 text-center text-[#143749]">Application Submission</h2>
        <div className="flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-1/2">
            <form onSubmit={handleSubmit}>
              <div className="mb-5">
                <label className="block mb-1 text-xs font-semibold text-gray-800">Name</label>
                <input
                  type="text"
                  value={name}
                  disabled
                  readOnly
                  className="border border-gray-300 text-sm p-2 w-full focus:outline-none focus:ring-2 focus:ring-[#143749] transition duration-200"
                />
              </div>
              <div className="mb-5">
                <label className="block mb-1 text-xs font-semibold text-gray-800">Mobile Number</label>
                <input
                  type="text"
                  value={mobile}
                  disabled
                  readOnly
                  className="border border-gray-300 text-sm p-2 w-full focus:outline-none focus:ring-2 focus:ring-[#143749] transition duration-200"
                />
              </div>
              <div className="mb-5">
                <label className="block mb-1 text-xs font-semibold text-gray-800">Email</label>
                <input
                  type="email"
                  value={email}
                  disabled
                  readOnly
                  className="border border-gray-300 text-sm p-2 w-full focus:outline-none focus:ring-2 focus:ring-[#143749] transition duration-200"
                />
              </div>
              <div className="mb-5">
                <label className="block mb-1 text-xs font-semibold text-gray-800">Resume/CV</label>
                <button
                  type="button"
                  onClick={handleViewResume}
                  className="flex items-center text-blue-600 hover:underline text-[13px]">
                  <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
                  View Resume
                </button>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="bg-[#005eb8] text-white py-2 rounded-sx w-full transition duration-200 hover:bg-[#005eb8] focus:outline-none focus:ring-2 focus:ring-[#143749]"
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
          <div className="w-full md:w-1/2 p-4 bg-[#bbd7f0] rounded-sx border border-gray-200 shadow-sx">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Job Snapshot</h3>
            <div className="space-y-6">
              <p className="text-sm font-medium text-gray-700">
                Job Title: <span className="font-normal text-gray-600">{product.jobTitle}</span>
              </p>
              <p className="text-sm font-medium text-gray-700">
                Company: <span className="font-normal text-gray-600">{product.companyName}</span>
              </p>
              <p className="text-sm font-medium text-gray-700">
                Location: <span className="font-normal text-gray-600">{product.location}</span>
              </p>
              <p className="text-sm font-medium text-gray-700">
                Salary: <span className="font-normal text-gray-600">₹{product.salary}/{product.salaryType}</span>
              </p>
              <p className="text-sm font-medium text-gray-700">
                Experience Required: <span className="font-normal text-gray-600">{product.experienceRequired}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UploadResume;
